import type { RuntimePhase } from "@/runtime/types";
import { statusMessage } from "@/journey/journeySteps";

/** Wireframe 2 · Preparing. */
export function PreparingScreen({ phase }: { phase: RuntimePhase }) {
  return (
    <section className="panel preparing-panel" role="status" aria-live="polite" data-testid="preparing">
      <span className="spinner" aria-hidden="true" />
      <h2>Checking your device…</h2>
      <p className="panel-note">{statusMessage(phase)}</p>
      <p className="panel-hint">Takes a couple seconds.</p>
    </section>
  );
}
